import styled from 'styled-components'
import { LoadingAnimation } from './LoadingAnimation'

interface IProps {
  animation?: 'grow' | 'border'
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark'
  size?: number
  className?: string
  message?: string
}

export const LoadingBox = ({ message, ...props }: IProps) => {
  return (
    <Div>
      <LoadingAnimation {...props} />

      {message && <p>{message}</p>}
    </Div>
  )
}

const Div = styled.div`
  position: absolute !important;
  inset: 0 0 0 0;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1em;
  background: inherit;
  backdrop-filter: blur(1px);
  z-index: 3;

  > p {
    ${({ theme }) => theme.typography.m.normal};
    color: ${({ theme }) => theme.colors.grey.dark};
  }
`
